/* RESPONSIBLE TEAM: team-standalone */
import Fragment from 'ember-data-model-fragments/fragment';
import { attr } from '@ember-data/model';

export default class HandoffToExternalTicketOnResolutionData extends Fragment {
  @attr('boolean') declare handoffEnabled: boolean;
  @attr('string') declare handoffToSalesforceOwnerId?: string;
}
